module.exports = __webpack_public_path__ + "static/img/2_1_3_1.86ce90bd.jpg";